<div
  class="black-quill-wrapper ql-theme-{{
    theme
  }} rounded-xl border border-base-content/20 bg-base-100 focus-within:border-primary focus-within:ring-2 focus-within:ring-primary/20 transition-all overflow-hidden relative"
  [class.ql-snow]="theme === 'snow'"
  [class.ql-bubble]="theme === 'bubble'"
  [class.daisy-disabled]="readOnly"
>
  <div
    #editorContainer
    class="black-quill-editor"
    [style.min-height]="minHeight"
    [style.max-height]="maxHeight || null"
  ></div>
</div>
